import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Tabs,
  Tab,
  Typography,
  Box,
  Button,
  Paper,
  IconButton,
  TextField,
  Menu,
  MenuItem,
  Avatar,
  Grid,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Pagination,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Skeleton,
  CircularProgress,
} from "@mui/material";
import Select from "react-select";
import DeleteIcon from "../assets/images/deleteIcon.png";
import EditIcon from "../assets/images/detailEdit.png";
import AddIcon from "@mui/icons-material/Add";
import { format } from "date-fns";
import AddNoteDialog from "./AddNotes";
import { DeleteNote, GetNoteList } from "../service/NotesService";
import { PreferencesContext } from "../PreferenceContext";
import { AlertType } from "../shared/AlertType";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import DefaultProfile from "../assets/images/DefaultProfile.png";
import AddStakeHolderDialog from "../components/AddStakeHolder";
import { GetTempTypeList } from "../service/TemperatureTypeService";
import { BASE_URL } from "../service/common/const";
import { UploadProfile } from "../service/UploadProfile";
import { GetStakeDetail } from "../service/StakeService";
import UploadProfileEdit from "../assets/images/uploadprofile.png";
import EditStakeIcon from "../assets/images/editStakeIcon.png";
import moreIcon from "../assets/images/moreIcon.png";
import DuplicateIcon from "../assets/images/duplicateIcon.png";
import CustomPagination from "./CustomPagination";

interface Stakeholder {
  CONTACT_DETAIL: string;
  UID: string;
  notes: any;
  ORG_NAME: string;
  FIRST_NAME: string;
  LAST_NAME: string;
  ROLE_NAME: string;
  TEAM_NAME: string;
}

const StakeHoldersDetail = ({
  stackholder,
  handleDeleteStack,
}: {
  stackholder: Stakeholder;
  handleDeleteStack: (UID: string) => void;
}) => {
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  // const [notes, setNotes] = useState({ TEMPERATURE_TYPE: "" });
  const [notes, setNotes] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [param, setParam] = useState({
    pageIndex: 1,
    pageSize: 10,
    sortBy: "",
  });
  const navigate = useNavigate();
  // const { token } = useParams();
  // const token = userContext?.token;
  const { token: tokenFromParams } = useParams();
  const token = tokenFromParams || userContext?.token;
  const urlToken = tokenFromParams;
  const [isLoading, setLoading] = useState(false);
  const [isLoadingNote, setLoadingNote] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteNoteId, setDeleteNoteId] = useState<any>(null);
  const [selectedImage, setSelectedImage] = useState<string>(DefaultProfile);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [temperatureTypeColl, setTemperatureTypeColl] = useState<any[]>([]);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedStakeholder, setSelectedStakeholder] = useState<any>(null);
  // Handle file upload
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result as string);
      };
      reader.readAsDataURL(file);
      uploadProfileImage(file, stackholder.UID);
    }
  };
  const [addNotesPopup, setAddNotesPopup] = useState<any>({
    open: false,
    stakeId: null,
    uid: null,
  });
  const [addStackHolderPopup, setAddStackHolderPopup] = useState<any>({
    open: false,
    stakeId: null,
    uid: null,
  });

  const handleOpenAddNotesPopup = (stakeId: any) => {
    setAddNotesPopup({ open: true, stakeId, uid: 0 });
  };

  const handleOpenEditNotesPopup = (stakeId: any, uid: number) => {
    setAddNotesPopup({ open: true, stakeId, uid });
  };

  const handleOpenEditStackHolderPopup = (uid: any) => {
    setAddStackHolderPopup({ open: true, uid });
  };
  const closeAddStakeHolderPopup = async (code?: string) => {
    if (code === "SUBMIT") {
      await getStakeDetail(stackholder?.UID);
    }
    setAddStackHolderPopup({ open: false, uid: null });
  };
  // Regex for detecting URLs/domains and emails
  const urlRegex = /((https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?)/gi;
  const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;

  // Function to parse text and return clickable links
  const parseLinks = (text?: string | null) => {
    if (!text) return null;

    const parts: React.ReactNode[] = [];
    let lastIndex = 0;

    const combinedRegex = new RegExp(
      `${urlRegex.source}|${emailRegex.source}`,
      "gi"
    );

    let match;
    while ((match = combinedRegex.exec(text)) !== null) {
      const { index } = match;
      if (index > lastIndex) {
        parts.push(text.slice(lastIndex, index));
      }

      const matchedText = match[0];

      // Simple check instead of .test() with global regex
      const isEmail = matchedText.includes("@");

      if (isEmail) {
        parts.push(
          <a
            key={index}
            href={`mailto:${matchedText}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1976d2", textDecoration: "underline" }}
          >
            {matchedText}
          </a>
        );
      } else {
        const url = matchedText.startsWith("http")
          ? matchedText
          : `https://${matchedText}`;
        parts.push(
          <a
            key={index}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1976d2", textDecoration: "underline" }}
          >
            {matchedText}
          </a>
        );
      }

      lastIndex = index + matchedText.length;
    }

    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }

    return parts;
  };
  const [stakeholderDetail, setStakeholderDetail] = useState({
    firstName: "",
    lastName: "",
    company: "",
    role: "",
    teamName: "",
    contact: "",
    temperature: "",
    notes: "",
    nodecolour: "",
    UID: 0,
    profileImage: "",
  });

  const closeNotesPopup = async (code?: string) => {
    if (code === "SUBMIT") {
      await fetchNotesForStack(stackholder.UID);
    }
    setAddNotesPopup({ open: false, stakeId: null, uid: null });
  };
  const handleMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    note: any
  ) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedStakeholder(note);
  };
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedStakeholder(null);
  };

  const fetchNotesForStack = async (
    UID: string,
    pageIndex: number = 1,
    pageSize: number = 10,
    sortBy: string = ""
  ) => {
    setLoadingNote(true);
    try {
      let response: any;
      let params = new URLSearchParams();
      params.append("STAKE_UID", UID);
      params.append("pageIndex", pageIndex.toString());
      params.append("pageSize", pageSize.toString());
      params.append("SORT_BY", sortBy);
      response = await GetNoteList(params);
      if (response?.data?.data?.notesColl) {
        setNotes(response?.data?.data?.notesColl);
        setTotalCount(response?.data?.data?.total_data_count);
      }
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      });
    } finally {
      setLoadingNote(false);
    }
  };

  const handleDeleteNote = (UID: any) => {
    setDeleteNoteId(UID);
    setOpenDeleteModal(true);
  };

  const handleConfirmDeleteNote = async () => {
    try {
      let response: any;
      response = await DeleteNote({
        UID: deleteNoteId,
      });
      if (response) {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: response.message,
          alertType: AlertType.Success,
        });
        setOpenDeleteModal(false);
        setDeleteNoteId(null);
        // Refresh the list after deletion
        fetchNotesForStack(stackholder.UID);
      }
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      });
    }
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setDeleteNoteId(null);
  };

  const getStakeDetail = async (UID: any) => {
    setLoading(true);
    try {
      const response: any = await GetStakeDetail({ UID });
      if (response?.data) {
        const mappedStakeDetailData = {
          UID: parseInt(response.data.data.UID),
          firstName: response.data.data.FIRST_NAME || "",
          lastName: response.data.data.LAST_NAME || "",
          company: response.data.data.ORG_NAME || "",
          role: response.data.data.ROLE_NAME || "",
          teamName: response.data.data.TEAM_NAME || "",
          contact: response.data.data.CONTACT_DETAIL || "",
          temperature: response.data.data.TEMPERATURE_TYPE || "",
          nodecolour: response.data.data.COLOUR_HASH_CODE || "",
          notes: response.data.data.INITIAL_NOTE || "",
          profileImage: response.data.data.PROFILE_IMAGE_BASE64 || "",
        };

        setStakeholderDetail(mappedStakeDetailData);
        return mappedStakeDetailData;
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    } finally {
      setLoading(false);
    }
  };

  const uploadProfileImage = async (file: File, uid: string | number) => {
    const formData = new FormData();
    formData.append("profile", file);
    formData.append("uid", uid.toString());
    try {
      const response = await UploadProfile(formData);
      if (response?.data?.filePath) {
        setSelectedImage(`${BASE_URL}${response.data.filePath}`);
        getStakeDetail(stackholder.UID);
      }
    } catch (error) {
      console.error("Upload error:", error);
    }
  };
  const fetchTemperatureTypeList = async () => {
    try {
      let params = new URLSearchParams();
      const response: any = await GetTempTypeList(params);

      if (response?.data) {
        setTemperatureTypeColl(response?.data);
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };

  const isOwner = !urlToken || urlToken === userContext?.localToken;
  useEffect(() => {
    if (stackholder) {
      fetchNotesForStack(
        stackholder.UID,
        param.pageIndex,
        param.pageSize,
        param.sortBy
      );
      getStakeDetail(stackholder.UID);
    }
    fetchTemperatureTypeList();
  }, [stackholder, param]);

  return (
    <Box
      sx={{
        width: "100%",
        gap: "48px",
      }}
    >
      {/* Main Info Section */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          padding: "30px",
        }}
      >
        <Box>
          <Box sx={{ position: "relative", width: 98, height: 98 }}>
            {isLoading ? (
              <Skeleton variant="circular" width={98} height={98} />
            ) : (
              <Avatar
                alt=" "
                src={stakeholderDetail.profileImage || selectedImage}
                sx={{ width: 98, height: 98 }}
              />
            )}
            {isLoading
              ? null
              : isOwner && (
                  // !!userContext?.userId &&
                  <IconButton
                    sx={{
                      p: 0,
                      position: "absolute",
                      borderRadius: 0,
                      minWidth: "auto",
                      bottom: 0,
                      right: 0,
                      width: 32,
                      height: 32,
                    }}
                    // onClick={() => fileInputRef.current?.click()}
                    onClick={(e) => {
                      handleOpenEditStackHolderPopup(stackholder?.UID);
                    }}
                  >
                    <img
                      src={UploadProfileEdit}
                      alt="Edit profile"
                      style={{ width: "32px", height: "32px" }}
                    />
                  </IconButton>
                )}
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </Box>
        </Box>
        <Box sx={{ width: "900px" }}>
          <Grid container spacing={2} mb={2}>
            <Grid
              size={12}
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              {isLoading ? (
                <Skeleton variant="text" width="50%" height={32} />
              ) : (
                <Typography
                  variant="h5"
                  fontWeight={500}
                  sx={{
                    // fontFamily: "'Courier New', Courier, monospace",
                    display: "block",
                    width: "100%",
                    wordBreak: "break-word",
                  }}
                  mb={1}
                >
                  {stakeholderDetail?.firstName} {stakeholderDetail?.lastName}
                </Typography>
              )}
              {isLoading ? (
                <Skeleton variant="circular" width={26} height={26} />
              ) : (
                isOwner && (
                  <img
                    src={EditStakeIcon}
                    alt="Add"
                    style={{ width: "26px", height: "26px", cursor: "pointer" }}
                    onClick={(e) => {
                      handleOpenEditStackHolderPopup(stackholder?.UID);
                    }}
                  />
                )
              )}
            </Grid>
          </Grid>

          <Grid container spacing={0.5}>
            <Grid size={2.3}>
              <Typography fontWeight={500} className="header-item">
                Company
              </Typography>
            </Grid>
            <Grid size={2.3}>
              <Typography fontWeight={500} className="header-item">
                Role
              </Typography>
            </Grid>
            <Grid size={1.8}>
              <Typography fontWeight={500} className="header-item">
                Department
              </Typography>
            </Grid>
            <Grid size={5.6}>
              <Typography fontWeight={500} className="header-item">
                Contacts/LinkedIn
              </Typography>
            </Grid>
            {/* <Grid size={2}>
              <Typography fontWeight={500} className="header-item">
                Latest Temperature
              </Typography>
            </Grid> */}
            <Grid size={2.3}>
              {isLoading ? (
                <Skeleton variant="text" width="50%" height={25} />
              ) : (
                <Typography
                  color="textSecondary"
                  sx={{
                    display: "block",
                    width: "100%",
                    wordBreak: "break-word",
                  }}
                >
                  {stakeholderDetail?.company}
                </Typography>
              )}
            </Grid>
            <Grid size={2.3}>
              {isLoading ? (
                <Skeleton variant="text" width="50%" height={25} />
              ) : (
                <Typography
                  color="textSecondary"
                  sx={{
                    display: "block",
                    width: "100%",
                    wordBreak: "break-word",
                  }}
                >
                  {stakeholderDetail?.role}
                </Typography>
              )}
            </Grid>
            <Grid size={1.8}>
              {isLoading ? (
                <Skeleton variant="text" width="50%" height={25} />
              ) : (
                <Typography
                  color="textSecondary"
                  // sx={{ whiteSpace: "pre-line" }}
                  sx={{
                    display: "block",
                    width: "100%",
                    wordBreak: "break-word",
                  }}
                >
                  {stakeholderDetail?.teamName}
                </Typography>
              )}
            </Grid>
            <Grid size={5.6}>
              {isLoading ? (
                <Skeleton variant="text" width="50%" height={25} />
              ) : (
                <Typography
                  color="textSecondary"
                  sx={{
                    display: "block",
                    width: "100%",
                    wordBreak: "break-word",
                  }}
                >
                  {/* {stakeholderDetail?.contact} */}
                  {parseLinks(stakeholderDetail?.contact || "")}
                </Typography>
              )}
            </Grid>
            {/* <Grid size={2}>
              {isLoading ? (
                <Skeleton variant="text" width="50%" height={25} />
              ) : (
                <Typography
                  color="textSecondary"
                  sx={{
                    display: "block",
                    width: "100%",
                    wordBreak: "break-word",
                  }}
                >
                  {notes[0]?.temperature?.NAME ||
                    stakeholderDetail?.temperature}
                </Typography>
              )}
            </Grid> */}
          </Grid>
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "none",
          paddingRight: "30px",
          paddingBottom: notes.length === 0 ? "30px" : 0,
        }}
      >
        <Table
          sx={{
            width: "100%",
            borderCollapse: "collapse",
            tableLayout: "fixed",
            " & td": {
              border: "1px solid #E0E0E0",
              // padding: "6px 8px",
              verticalAlign: "middle",
              minHeight: "500px !important",
              height: "100%",
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{ borderBottom: "none !important", width: "30px" }}
              ></TableCell>
              <TableCell sx={{ width: "183px", textAlign: "center" }}>
                <Typography className="header-item">Date</Typography>
              </TableCell>
              <TableCell sx={{ width: "175px", textAlign: "center" }}>
                <Typography className="header-item">Status</Typography>
              </TableCell>
              <TableCell sx={{ width: "662px", textAlign: "center" }}>
                <Typography className="header-item">Notes</Typography>
              </TableCell>
              {/* {userContext?.userId === userContext?.stakemapUserId && (
                <TableCell align="right">Actions</TableCell>
              )} */}
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoadingNote
              ? Array.from({ length: 4 }, (_, i) => (
                  <TableRow key={i}>
                    <TableCell
                      sx={{
                        borderTop: "none !important",
                        borderLeft: "none !important",
                        borderBottom: "none !important",
                      }}
                    ></TableCell>
                    <TableCell colSpan={3}>
                      <Skeleton variant="rounded" width="100%" height={25} />
                    </TableCell>
                  </TableRow>
                ))
              : notes?.map((note: any) => (
                  <TableRow key={note?.UID}>
                    <TableCell
                      sx={{
                        borderTop: "none !important",
                        borderLeft: "none !important",
                        borderRight: "1px solid #E0E0E0 !important",
                        borderBottom: "none !important",
                        padding: "0 !important",
                        width: "30px",
                        paddingLeft: "8px !important",
                      }}
                    >
                      {isOwner && (
                        <IconButton
                          sx={{
                            // paddingLeft: "4px",
                            padding: "0 !important",
                            "&:hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMenuClick(e, note);
                          }}
                        >
                          <img
                            src={moreIcon}
                            alt="edit"
                            style={{ width: 16, height: 16 }}
                          />
                        </IconButton>
                      )}
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "183px",
                        borderLeft:
                          "6px solid rgba(196, 196, 196, 1) !important",
                      }}
                    >
                      <Typography
                        className="value-item"
                        sx={{ textAlign: "center" }}
                      >
                        {note?.NOTES_DATE
                          ? format(new Date(note.NOTES_DATE), "dd/MM/yyyy")
                          : ""}
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "175px",
                        height: "100%",
                        verticalAlign: "top",
                        position: "relative",
                      }}
                      className="tabel-data"
                    >
                      <Box
                        sx={{
                          // backgroundColor: note?.TEMPERATURE_COLOUR_CODE || "white",
                          backgroundColor:
                            note?.temperature?.COLOUR_HASH_CODE || "white",
                          position: "absolute",
                          top: 4,
                          left: 4,
                          right: 4,
                          bottom: 4,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "4px",
                          color: "rgba(51, 0, 1, 1)",
                          padding: "0 4px",
                        }}
                      >
                        {note?.temperature?.NAME}
                      </Box>
                    </TableCell>
                    <TableCell sx={{ width: "662px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          className="value-item"
                          sx={{
                            display: "block",
                            width: "100%",
                            height: "100%",
                            overflowY: "auto",
                            overflowX: "hidden",
                            wordBreak: "break-word",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {note?.NOTES_TEXT}
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}

            {isLoading
              ? null
              : isOwner && (
                  // !!userContext?.userId &&
                  <TableRow style={{ height: "44px" }}>
                    <TableCell
                      sx={{
                        borderTop: "none !important",
                        borderLeft: "none !important",
                        borderRight: "1px solid #E0E0E0 !important",
                        borderBottom: "none !important",
                        padding: 0,
                        width: "4%",
                      }}
                    />
                    <TableCell
                      colSpan={3}
                      onClick={() => handleOpenAddNotesPopup(stackholder?.UID)}
                      className="edit-note-menu-item"
                      sx={{
                        borderLeft:
                          "6px solid rgba(196, 196, 196, 0.5) !important",
                        cursor: "pointer",
                      }}
                    >
                      <AddIcon sx={{ width: "10px", height: "10px" }} /> Add
                      notes
                    </TableCell>
                  </TableRow>
                )}
          </TableBody>
        </Table>
      </TableContainer>

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "10px 30px 10px 10px",
          }}
        >
          <Skeleton variant="text" width={"50%"} height={25} />
        </Box>
      ) : (
        notes.length > 0 && (
          <Box sx={{ paddingRight: "30px" }}>
            <CustomPagination
              param={param}
              setParam={setParam}
              totalCount={totalCount}
            />
          </Box>
        )
      )}

      {/* <Grid sx={{ paddingTop: "8px" }}>
        {notes.length > 0 && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body2">
              {`${(param.pageIndex - 1) * param.pageSize + 1} - ${Math.min(
                param.pageIndex * param.pageSize,
                totalCount
              )} of ${totalCount}`}
            </Typography>
            <Pagination
              page={param.pageIndex}
              count={Math.ceil(totalCount / param.pageSize)}
              onChange={(e, value) =>
                setParam((prev) => ({ ...prev, pageIndex: value }))
              }
              color="primary"
              sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "8px",
                },
              }}
            />
          </Box>
        )}
      </Grid> */}

      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            borderRadius: "4px",
            minWidth: 180,
            p: 1,
          },
        }}
      >
        <MenuItem
          className="edit-note-menu-item"
          sx={{
            paddingLeft: 0,
            padding: 0,
          }}
          onClick={(e) => {
            e.preventDefault();
            handleMenuClose();
            handleOpenEditNotesPopup(
              selectedStakeholder?.STAKE_UID,
              selectedStakeholder?.UID
            );
          }}
        >
          <ListItemIcon>
            <img
              src={EditStakeIcon}
              alt="note"
              style={{ width: 25, height: 25, color: "rgba(35, 35, 35, 1)" }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Edit"
            className="popup-text"
            style={{ color: "rgba(35, 35, 35, 1)" }}
          />
        </MenuItem>

        {/* <MenuItem
          className="edit-note-menu-item"
          sx={{
            paddingLeft: 0,
            padding: "3px 0px 3px 0px",
          }}
          // onClick={(e) => {
          //   e.preventDefault();
          //   handleMenuClose();
          //   handleOpenEditNotesPopup(
          //     selectedStakeholder?.STAKE_UID,
          //     selectedStakeholder?.UID
          //   );
          // }}
        >
          <ListItemIcon>
            <img
              src={DuplicateIcon}
              alt="Duplicate"
              style={{
                width: 18,
                height: 14,
                color: "rgba(35, 35, 35, 1)",
                paddingLeft: "5px",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Duplicate"
            className="popup-text"
            style={{ color: "rgba(35, 35, 35, 1)" }}
          />
        </MenuItem> */}

        <MenuItem
          className="delete-note-menu-item"
          sx={{
            paddingLeft: "0",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleMenuClose();
            handleDeleteNote(selectedStakeholder?.UID);
          }}
        >
          <ListItemIcon className="delete-list-item-icon">
            {/* <DeleteIcon fontSize="small" className="delete-icon" />   */}
            <img src={DeleteIcon} alt="delete" style={{ paddingLeft: "5px" }} />
          </ListItemIcon>
          <ListItemText
            primary="Delete"
            className="delete-text  popup-text"
            style={{ color: "rgba(104, 0, 1, 1)" }}
          />
        </MenuItem>
      </Menu>

      <AddNoteDialog
        open={addNotesPopup.open}
        onClose={closeNotesPopup}
        UID={addNotesPopup?.uid || 0}
        STAKEUID={addNotesPopup?.stakeId || 0}
      />

      <AddStakeHolderDialog
        open={addStackHolderPopup.open}
        onClose={closeAddStakeHolderPopup}
        UID={addStackHolderPopup?.uid || 0}
      />
      <Dialog
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Typography id="alert-dialog-description">
            Are you sure you want to delete this note?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleConfirmDeleteNote}
            variant="contained"
            color="error"
            sx={{ backgroundColor: "#4C0808" }}
          >
            Yes, Delete
          </Button>
          <Button
            onClick={handleCloseDeleteModal}
            variant="outlined"
            sx={{ backgroundColor: "#ffffff" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StakeHoldersDetail;
